export default {
	url: process.env.REACT_APP_API_URL,
};